/** A refresh re-reads the flags, which recovers both a refused price and a transient failure. */
export const CHECKOUT_ERROR_MESSAGE =
  "We couldn't start checkout. Refresh the page and try again, or contact support and we'll sort it out."
